import { evidenceItems } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";

export default function EvidenceSection() {
  return (
    <section id="evidence" className="bg-background-50">
      <div className="mx-auto max-w-[1400px] px-4 py-10 md:px-8 md:py-14">
        <Reveal>
          <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
            <div>
              <span className="text-xs text-primary-600">新证据不断浮出水面</span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                证据柜
              </h2>
            </div>
            <p className="max-w-md text-sm leading-relaxed text-foreground-600">
              画面、资金、文本三类材料分栏呈现，未核实的部分我们会明确标注，请以官方通报为准。
            </p>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 md:gap-6">
          {evidenceItems.map((item, index) => (
            <Reveal key={item.title} delay={index * 90}>
              <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50">
                <div className="relative h-44 w-full md:h-48">
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.title} 网曝黑料 新证据`}
                    className="h-full w-full object-cover object-top"
                  />
                  <span className="absolute left-3 top-3 rounded-md bg-background-50/95 px-2.5 py-1 text-[11px] font-medium text-foreground-800">
                    {item.tag}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-5">
                  <div className="flex items-center justify-between text-[11px] text-foreground-500">
                    <span>整理时间 {item.date}</span>
                    <span className="flex items-center gap-1 text-primary-600">
                      <i className="ri-search-eye-line" />
                      待核实
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">
                    {item.summary}
                  </p>
                  <a
                    href="#evidence"
                    className="mt-auto flex items-center gap-1 pt-4 text-sm font-medium text-primary-600 hover:text-primary-700"
                  >
                    查看材料说明
                    <i className="ri-arrow-right-s-line" />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}